import { Grid,Container,Divider, makeStyles} from '@material-ui/core';
import facebookIcon from './facebookIcon.svg';
import instagramIcon from './instagramIcon.svg';
import linkedinIcon from './linkedinIcon.svg';

export default function Footer(){

const useStyles = makeStyles({
    root: {
        display:'flex',
        left: 0,
        background: 'linear-gradient(92.93deg, #7006A2 0%, #D376FF 101.22%)',
        textAlign:'center'
        },
    divIcon:{
        display:'block',
        alignItems:'center',
        position:'relative',
        padding:'50'

    },
    divLinks:{
        display:'inline-flex',
        alignItems:'center',
        position:'relative',
        padding:'50'

    },
    a:{
        textDecoration:'none',
        margin: 10,
        color:'#FFFFFF'
    },
    p:{
        textDecoration:'none',
        margin: 10,
        color:'#FFFFFF'
    },
    footer:{
        padding:40,
    },
    divider:{
        background:'#FFFFFF'
    }
  });
      const classes = useStyles();

    return(
        <footer className={classes.root}>
            <Container className={classes.footer}>
                <Grid className={classes.divIcon}>
                    <a className={classes.a} target="_blank" rel="noreferrer" href="https://www.facebook.com/direitoagilwebapp"><img src={facebookIcon} alt='icone do facebook'/></a>
                    <a target="_blank" rel="noreferrer" href="https://www.instagram.com/direitoagil1/"><img src={instagramIcon} alt='icone do instagram'/></a>
                    <a className={classes.a} target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/maria-da-penha-virtual/"><img src={linkedinIcon} alt='icone do linkedin'/></a>
                </Grid>
                <Grid className={classes.divLinks}>
                    <a className={classes.a} href="#cases">Nossas Cases</a>
                    <p className={classes.p}>*</p>
                    <a className={classes.a} href="#aboutUs">Sobre Nós</a>
                </Grid>
                <Divider variant="middle" classes={{root: classes.divider}}/>
            </Container>
        </footer>
    )
}